import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { ThemeProvider } from 'styled-components';
import './index.css';
import './i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { theme } from './theme/theme';
import { GlobalStyle } from './theme/GlobalStyle';
import { store, persistor } from './store';
import { LanguageProvider } from './contexts/LanguageContext';

try {
  document.querySelectorAll('head [data-prerender="1"]').forEach((el) => el.remove());
} catch {
  /* no-op */
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <LanguageProvider>
            <ThemeProvider theme={theme}>
              <GlobalStyle />
              <App />
            </ThemeProvider>
          </LanguageProvider>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
);

reportWebVitals();
